(() => {
  if (customElements.get('btk-size-alternatives')) return;
  class BtkSizeAlternatives extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.details = this.querySelector('details');
      this.select = this.querySelector('[data-requested-size]');
      this.status = this.querySelector('[data-status]');
      this.empty = this.querySelector('[data-no-match]');
      this.source = JSON.parse(this.querySelector('[data-source-variants]').textContent);
      this.words = JSON.parse(this.querySelector('[data-alternatives-strings]').textContent);
      this.cards = [...this.querySelectorAll('[data-alternative]')].map(element => ({
        element,
        variants: JSON.parse(element.querySelector('[data-alternative-variants]').textContent)
      }));
      this.select.addEventListener('change', () => this.render(), {signal: this.controller.signal});
      document.addEventListener('variant:change', event => {
        if (event.detail?.formId !== this.dataset.formId) return;
        const selected = this.source.find(v => String(v.id) === String(event.detail.variant?.id));
        if (!selected) return;
        this.select.value = selected.available ? '' : selected.size;
        this.details.open = !selected.available;
        this.render();
      }, {signal: this.controller.signal});
      this.render();
    }
    disconnectedCallback() { this.controller?.abort(); }
    text(key, size) { return this.words[key].replaceAll('[size]', size); }
    render() {
      const size = this.select.value;
      const sourceAvailable = this.source.some(v => v.size === size && v.available);
      let shown = 0;
      for (const card of this.cards) {
        const variant = card.variants.find(v => v.size === size && v.available);
        const visible = Boolean(size && !sourceAvailable && variant && shown < 2);
        card.element.hidden = !visible;
        if (!visible) continue;
        shown++;
        const url = new URL(card.element.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', variant.id);
        card.element.querySelectorAll('[data-alternative-link]').forEach(a => { a.href = url.pathname + url.search; });
        card.element.querySelector('[data-alt-price]').textContent = variant.price;
        card.element.querySelector('[data-alt-size]').textContent = this.text('stock', size);
        card.element.querySelector('[data-view-link]').textContent = this.text('view', size);
      }
      this.status.textContent = !size ? '' : this.text(sourceAvailable ? 'source' : shown ? 'matches' : 'none', size);
      this.empty.hidden = !size || sourceAvailable || shown > 0;
    }
  }
  customElements.define('btk-size-alternatives', BtkSizeAlternatives);
})();
